module.exports = __webpack_public_path__ + "static/media/06.c3b2178d.jpg";